import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  { path: '/', redirect: '/module1' },
  { path: '/module1', name: 'Module1', component: () => import('@/views/Module1.vue') },
  { path: '/module2', name: 'Module2', component: () => import('@/views/Module2.vue') },
  { path: '/module3', name: 'Module3', component: () => import('@/views/Module3.vue') },
  { path: '/module4', name: 'Module4', component: () => import('@/views/Module4.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
